import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { PromoSectionContainer } from 'components/no-auth/common/PromoSectionContainer';
import { RichTextTile } from 'components/no-auth/common/RichTextTile/RichTextTile';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const CookiesPage = (props) => {
    return (
        <PromoPageContainer bgColor="eggshell03">
            {props.heroTitle && <HeroSection title={props.heroTitle} data={props.heroData} />}
            <PromoSectionContainer dimension="average">{props.content && <RichTextTile text={props.content} />}</PromoSectionContainer>
        </PromoPageContainer>
    );
};

CookiesPage.propTypes = {
    heroTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    heroData: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroData: state.extra?.strapiApi?.hero_block,
        content: state.extra?.strapiApi?.cookies_content,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(CookiesPage));
